import React, { createContext, useEffect, useState } from "react"

export const Context = createContext()

export const ContextProvider = ({ children }) => {
  const [dateFilter, setDateFilter] = useState(() => {
    const savedFilter = localStorage.getItem("dateFilter")
    return savedFilter
      ? JSON.parse(savedFilter)
      : { date_from: "", date_to: "" }
  })

  const [currentTab, setCurrentTab] = useState(() => {
    return localStorage.getItem("currentTab") || ""
  })

  useEffect(() => {
    if (dateFilter.date_from || dateFilter.date_to) {
      localStorage.setItem("dateFilter", JSON.stringify(dateFilter))
    } else {
      localStorage.removeItem("dateFilter")
    }
  }, [dateFilter])

  const setDateFrom = (date_from) => {
    setDateFilter((prevFilter) => ({ ...prevFilter, date_from }))
  }

  const setDateTo = (date_to) => {
    setDateFilter((prevFilter) => ({ ...prevFilter, date_to }))
  }

  const clearDateFilter = () => {
    setDateFilter({ date_from: "", date_to: "" })
    localStorage.removeItem("dateFilter")
  }

  const clearCurrentTab = () => {
    setCurrentTab("")
    localStorage.removeItem("currentTab")
  }

  useEffect(() => {
    if (currentTab) {
      localStorage.setItem("currentTab", currentTab)
    } else {
      localStorage.removeItem("currentTab")
    }
  }, [currentTab])

  return (
    <Context.Provider
      value={{
        dateFilter,
        setDateFrom,
        setDateTo,
        clearDateFilter,
        clearCurrentTab,
        currentTab,
        setCurrentTab,
      }}
    >
      {children}
    </Context.Provider>
  )
}
